import { Cable, ClipboardList, FilePlus2, FileText, FileX2, Globe, ImagePlus, Plug, Sparkles, Workflow, type IconComponent } from '@digital-twins/design-system/icons'
import type { ActivityTargetKey } from '@/lib/constants/languages'
import { ENTITY_ICONS } from '@/lib/icons/entityIcons'

export const ACTIVITY_CHIP_ICONS: Record<ActivityTargetKey, IconComponent> = {
  analyze_results: ENTITY_ICONS.study,
  revise_run_step: Workflow,
  propose_social_tracker: ENTITY_ICONS.social,
  read_room: ENTITY_ICONS.room,
  read_study: ENTITY_ICONS.study,
  ask_study: ENTITY_ICONS.study,
  read_document: FileText,
  read_tracker_posts: ENTITY_ICONS.social,
  analyze_table: ENTITY_ICONS.dataset,
  report_reading: ENTITY_ICONS.research,
  report_writing: FileText,
  report_checking: FileText,
  web_search: Globe,
  document_search: ENTITY_ICONS.library,
  read_skill: Sparkles,
  read_workflow: Workflow,
  read_audience: ENTITY_ICONS.audience,
  read_results: ENTITY_ICONS.study,
  analyze_audience: ENTITY_ICONS.audience,
  read_artifact: FileText,
  update_artifact: FileText,
  create_artifact: FilePlus2,
  delete_artifact: FileX2,
  run_workflow: Workflow,
  research_search: ENTITY_ICONS.research,
  analyze_tracker_posts: ENTITY_ICONS.social,
  generate_image: ImagePlus,
  write_report: FileText,
  prepare_study: ClipboardList,
  prepare_quick_study: ClipboardList,
  list_datasets: ENTITY_ICONS.dataset,
  search_connected_sources: Cable,
  call_connected_source: Plug,
  read_social_topic: ENTITY_ICONS.social,
  analyze_social_topic: ENTITY_ICONS.social,
  search_social_posts: ENTITY_ICONS.social,
  read_social_post: ENTITY_ICONS.social,
  prepare_conversation: ENTITY_ICONS.room,
  tracker_search: ENTITY_ICONS.social,
}
